module.exports = __webpack_public_path__ + "static/media/pipeten_active_handschuhe_true_1.ec982359.jpg";